class VwHbsRaportiptanimverigirisDTO {
    id: number = 0;
    raportiptanimId?: number = null;
    adi?: string = "";
    sira?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    raporAdi?: string = "";
}
export default VwHbsRaportiptanimverigirisDTO;